import { render, staticRenderFns } from "./JsonInputObject.vue?vue&type=template&id=4f319a4b&scoped=true&"
import script from "./JsonInputObject.vue?vue&type=script&lang=js&"
export * from "./JsonInputObject.vue?vue&type=script&lang=js&"
import style0 from "./JsonInputObject.vue?vue&type=style&index=0&id=4f319a4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f319a4b",
  null
  
)

export default component.exports